/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_About_StoryInputs */

const en_placeholder_about_story = /** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell your buyers who you are and why you do what you do...`)
};

const es_placeholder_about_story = /** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntale a tus compradores quién eres y por qué haces lo que haces...`)
};

const fr_placeholder_about_story = /** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dites à vos acheteurs qui vous êtes et pourquoi vous faites ce que vous faites...`)
};

const de_placeholder_about_story = /** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sag deinen Käufern, wer du bist und warum du tust, was du tust...`)
};

const id_placeholder_about_story = /** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beri tahu pembeli siapa Anda dan mengapa Anda melakukan ini...`)
};

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const ja_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const zh_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const ar_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const it_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const ru_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const pt_placeholder_about_story = en_placeholder_about_story;

/** @type {(inputs: Placeholder_About_StoryInputs) => LocalizedString} */
const ko_placeholder_about_story = en_placeholder_about_story;

/**
* | output |
* | --- |
* | "Tell your buyers who you are and why you do what you do..." |
*
* @param {Placeholder_About_StoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_about_story = /** @type {((inputs?: Placeholder_About_StoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_About_StoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_about_story(inputs)
	if (locale === "es") return es_placeholder_about_story(inputs)
	if (locale === "fr") return fr_placeholder_about_story(inputs)
	if (locale === "de") return de_placeholder_about_story(inputs)
	if (locale === "ja") return ja_placeholder_about_story(inputs)
	if (locale === "zh") return zh_placeholder_about_story(inputs)
	if (locale === "ar") return ar_placeholder_about_story(inputs)
	if (locale === "id") return id_placeholder_about_story(inputs)
	if (locale === "it") return it_placeholder_about_story(inputs)
	if (locale === "ru") return ru_placeholder_about_story(inputs)
	if (locale === "pt") return pt_placeholder_about_story(inputs)
	return ko_placeholder_about_story(inputs)
});